import { render } from "./stock-in.vue?vue&type=template&id=8e1f9e3a&scoped=true"
import script from "./stock-in.vue?vue&type=script&lang=js"
export * from "./stock-in.vue?vue&type=script&lang=js"

import "./stock-in.vue?vue&type=style&index=0&id=8e1f9e3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1f9e3a"]])

export default __exports__